var constants = require('../constants');
var utils = require('../utils');
var fetchActions = require('./surveys-fetch');

var updateSurveyProgress = (function() {

    var _updateSurveyProgress = function() {
        return function(dispatch, getState){
            dispatch(fetchActions.fetchSurveysIfNeeded(getState().surveys.index.join(), getState().auth.token)).then(function() {
                var state = getState();
                var surveyArray = state.surveys.index;
                var oldProgress = state.surveys.progress;
                var surveys = state.entities.surveys;
                
                var answeredQuestionsOffset = 0;
                for(var i = 0; i < state.surveys.currentSurveyIndex; i++){
                    answeredQuestionsOffset += utils.getSequenceLength(surveys, surveyArray[i]);
                }
                answeredQuestionsOffset += state.surveys.currentSequenceIndex;

                var totalQuestionsNum = 0;
                surveyArray.forEach(function(surveyId){
                    totalQuestionsNum += utils.getSequenceLength(surveys, surveyId);
                });

                var newProgress = Math.round(answeredQuestionsOffset/totalQuestionsNum*100);

                var finalProgress = Math.max(oldProgress, newProgress);

                dispatch({
                    type: constants.UPDATE_SURVEY_PROGRESS,
                    progress: finalProgress
                });
            });
        };
    }

    return {
        updateSurveyProgress: _updateSurveyProgress
    }
})();

module.exports = updateSurveyProgress;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-update-progress.js